import { z } from "zod";

/// Detail-page tab vocabulary. Order matches the tab strip reading order.
/// `overview` is the "everything stacked" view (default landing); the
/// per-section tabs filter the main column to one focused chapter, same
/// model as the Feedback scope tabs.
export const ONE_ON_ONE_DETAIL_TABS = [
  "overview",
  "agenda",
  "notes",
  "actions",
  "discussion",
] as const;
export type OneOnOneDetailTab = (typeof ONE_ON_ONE_DETAIL_TABS)[number];

export const oneOnOneDetailRouteSearchSchema = z
  .object({
    tab: z.enum(ONE_ON_ONE_DETAIL_TABS).catch("overview").default("overview"),
  })
  .strict();
export type OneOnOneDetailRouteSearch = z.infer<typeof oneOnOneDetailRouteSearchSchema>;
